import angular from 'angular';

import tszPricing from './tsz-pricing';

const tszPricingModule = angular.module('tsz.components.tszPricing', [])
  .component('tszPricing', tszPricing);

export default tszPricingModule;



// WEBPACK FOOTER //
// ./src/components/tsz-pricing/tsz-pricing.module.js